const constants = {
  ESCAPED_COMMA_PLACEHOLDER: '::__COMMA__::',
  EMPTY: '::__EMPTY__::',
  PRIMARY_LINE_ITEM: 'primaryLineItem',
  SPLIT_LOAD_CONTAINER: 'splitLoadContainer',
  SPLIT_LOAD_MAT_SALES_TEXT: 'splitLoadMatSalesText',
  SPLIT_LOAD_REFERENCE_NUMBER: 'splitLoadReferenceNumber',
  OR: 'or::',
  IF: 'if::',
  GT: 'gt::',
  UOM: 'uom::',
  DATE_TIME: 'dateTime::',
  TRUCK_SEAL: 'truckSeal',
  ORDER_CODE: 'orderCode',
  SEQUENCE: 'sequence',
  SUPER_P_TYPE: 'superPType',
  MILL_CERTIFICATION: 'millCertification',
};

export default constants;
